import _ from 'lodash'
import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'
import SqaureLoader from '../../../components/Loader/SqaureLoader'
import { getTravailVisiteDetails } from '../../../services/Rapports/TravailVisiteApi'
import { SECTION_TITLES, colorForRate, pct } from './travailVisiteConstants'

/**
 * Panneau latéral (même présentation que VisitReportDetail) :
 * réponses Oui / Non par section. Fermeture : bouton, Échap ou clic sur le fond.
 */
export default function TravailVisiteDetail({ code, t, onClose }) {
    const [loading, setloading] = useState(true)
    const [data, setdata] = useState(null)
    const closeRef = useRef(null)

    useEffect(() => {
        setloading(true)
        getTravailVisiteDetails(code)
            .then((result) => {
                if (result?.data?.success === 1) setdata(result.data)
            })
            .catch((err) => console.log(err))
            .finally(() => setloading(false))
    }, [code])

    useEffect(() => {
        closeRef.current?.focus()
        const onKey = (e) => { if (e.key === 'Escape') onClose() }
        document.addEventListener('keydown', onKey)
        document.body.style.overflow = 'hidden'
        return () => {
            document.removeEventListener('keydown', onKey)
            document.body.style.overflow = ''
        }
    }, [onClose])

    const h = data?.header
    const actions = data?.actions || []
    const bySection = _.groupBy(actions, 'section')
    const nbOui = actions.filter((a) => Number(a.realise) === 1).length
    const p = pct(nbOui, actions.length)

    return (
        <div className="vrr-overlay" onClick={onClose}>
            <aside
                className="vrr-drawer"
                role="dialog"
                aria-modal="true"
                aria-label={t('Détail du travail effectué')}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="vrr-drawer-head">
                    <div>
                        <h2>{h ? (h.nompdv || h.pdv_code) : t('Travail effectué')}</h2>
                        {h && (
                            <p>
                                {moment(h.date_visite).format('dddd D MMMM YYYY')}
                                {h.heure_debut && ` · ${h.heure_debut}`}{h.heure_fin && ` – ${h.heure_fin}`}<br />
                                {h.user || h.user_code}
                            </p>
                        )}
                    </div>
                    <button ref={closeRef} type="button" className="vrr-close" onClick={onClose} aria-label={t('Fermer')}>
                        <i className="fe fe-x" />
                    </button>
                </div>

                <div className="vrr-drawer-body">
                    {loading ? <SqaureLoader /> : !data ? (
                        <p className="vrr-muted">{t('Ce travail est introuvable. Il a peut-être été supprimé.')}</p>
                    ) : (
                        <>
                            <section className="vrr-block trv-summary">
                                <span className="vrr-note vrr-note-lg" style={{ '--note-color': colorForRate(p) }}>
                                    {nbOui}/{actions.length}
                                </span>
                                <span>{t('actions réalisées')}</span>
                            </section>

                            {Object.keys(SECTION_TITLES).map((section) =>
                                bySection[section] ? (
                                    <section className="vrr-block" key={section}>
                                        <h3>{section} {t(SECTION_TITLES[section])}</h3>
                                        <ul className="trv-answers">
                                            {bySection[section].map((a) => {
                                                const oui = Number(a.realise) === 1
                                                return (
                                                    <li key={a.cle}>
                                                        <span>{t(a.libelle_fr)}</span>
                                                        <span className={`trv-pill ${oui ? 'trv-pill-oui' : 'trv-pill-non'}`}>
                                                            {oui ? t('Oui') : t('Non')}
                                                        </span>
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    </section>
                                ) : null
                            )}

                            {h.latitude && h.longitude && (
                                <a
                                    className="vrr-link"
                                    href={`https://www.google.com/maps?q=${h.latitude},${h.longitude}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <i className="fe fe-map-pin mr-1" />{t('Voir la position GPS')}
                                </a>
                            )}
                        </>
                    )}
                </div>
            </aside>
        </div>
    )
}
